import React from "react";
import BannerSwiper from "../components/BannerSwiper/BannerSwiper";
import ReactDOM from "react-dom";
const renderBannerSwipers = () => {
    const rows = document.getElementsByClassName("ds-banner-swiper-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    const client = window.DriveServiceSpecials.client;
    for (let index = 0; index < rows.length; index++) {
        const row = rows[index];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        const rowData = parent.div_rows.find(
            (rowObj) => rowObj.id === parseInt(row.id)
        );
        const { banner_swiper } = rowData;

        const commonDataAttr = {
            "data-divid": parent.id,
            "data-rowid": rowData.id,
            "data-clientid": client.id,
        };
        const bannerSwiperProps = {
            banner_swiper: banner_swiper,
            divId: parent.id,
            rowId: rowData.id,
            client,
            dataAttributes: commonDataAttr,
            rowData,
        };
        ReactDOM.render(<BannerSwiper {...bannerSwiperProps} />, row);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderBannerSwipers();
window.renderBannerSwipers = renderBannerSwipers;
export default renderBannerSwipers;
